import { raceWithAbort } from '@lucidlink/tscore';
const releaseIterator = async (iterator) => {
    try {
        await iterator.return?.();
    }
    catch {
    }
};
export async function* abortableIterable(iterable, signal) {
    const iterator = iterable[Symbol.asyncIterator]();
    try {
        while (true) {
            signal.throwIfAborted();
            const result = await raceWithAbort(iterator.next(), signal);
            if (result.done) {
                return;
            }
            yield result.value;
        }
    }
    finally {
        void releaseIterator(iterator);
    }
}
